/**
 * AddShowSetCtrl controller
 */

import {
  RENT_LENGTH_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES_LABELS,
  SHOWSET_TYPES
} from '../../app/core/constants'
import { findIn } from '../../app/helpers/entity'
import { isTvDip } from '../../app/helpers/fn'
import { checkCSIntersection, newItemPriceError, openCSModal } from './addChannelSet.controller'
import { getItemsPage } from '../../app/helpers/page'

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

AddShowSetCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddTVShoSetCtrl controller
 *
 * @class AddShowSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddShowSetCtrl
 */
/* @ngInject */
export default function AddShowSetCtrl ($scope, $http, $location, $uibModal, ShowSet, alertLiteSvc, NetworkCurrency, cs, pckg) {
  var vm = this

  /**
   *
   * @type {{[periodName:string]: string}}
   */
  vm.rentLengthTypes = RENT_LENGTH_TYPES

  vm.ready = false
  vm.showFromSeason = {}
  vm.showFromEpisode = {}
  vm.seasonFromEpisode = {}
  vm.draggableType = ''
  vm.fromTyp = ''
  vm.cachedItemType = cs.itemType

  vm.showSet_types = SHOWSET_TYPES

  vm.set_pricing_payment_method_types = angular.copy(SET_PRICING_PAYMENT_METHOD_TYPES)
  vm.set_pricing_payment_method_types_labels = angular.copy(SET_PRICING_PAYMENT_METHOD_TYPES_LABELS)
  vm.types = Object.keys(vm.set_pricing_payment_method_types)
  if (window.ENV.APP_CS_PER_ITEM_ENABLED !== 'true') {
    vm.types = ['PER_SET']
  }

  /**
   * Show Set
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   * @type {models.ShowSet}
   */
  vm.ss = cs

  vm.cashedItemType = cs.itemType

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  vm.notTvDip = !isTvDip()

  /**
   * Currencies list
   *
   * @memberof mwApp/settings.controller:PaymentSystemCtrl
   * @name vm.currencies
   * @type {models.NetworkCurrency[]}
   */

  // load currencies
  NetworkCurrency.loadAll({ network: pckg })
    .then(data => data.filter(c => c.enabled))
    .to(vm.currencies = [])
    .then(() => {
      vm.ss.pricing.currency = vm.ss.pricing.currency
        ? findIn(vm.currencies)(vm.ss.pricing.currency)
        : vm.currencies[0]
    })
    .finally(() => { vm.extraLoaded = true })

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   * @type {Boolean}
   */
  vm.isNew = cs._isNew()

  /**
   * Filter value for vod sets
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   * @type {string}
   */
  vm.filter = ''

  /**
   * Items arrays
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   * @type {Object}
   */
  vm.items = {
    available: {
      name: 'available',
      shows: []
    },
    assigned: {
      name: 'assigned',
      shows: []
    }
  }
  vm.tvShowIdsToRemove = []
  vm.seasonIdsToRemove = []
  vm.episodeIdsToRemove = []

  /**
   * Search content params with default values
   *
   * @memberof mwApp/reports.controller:AddShowSetCtrl
   * @type {Object}
   */
  vm.searchContentParams = {
    q: '',
    page: 0,
    last: false,
    count: 25
  }

  // initialize params
  vm.searchContentAssignedParams = angular.copy(vm.searchContentParams)
  vm.searchContentAvailableParams = angular.copy(vm.searchContentParams)

  /**
   * Get available show
   *
   * @memberof mwApp/reports.controller:AddShowSetCtrl
   * @type {Object}
   */

  vm.isNotEmptyShow = function (show) {
    const notEmpty = !!show.seasons.length

    switch (vm.ss.itemType) {
      case vm.showSet_types.season:
        return notEmpty && show.withSeason
      case vm.showSet_types.episode:
        return notEmpty
      default:
        return true
    }
  }

  vm.seasonSetId = function () {
    if (vm.isNew) {
      return null
    } else {
      if (vm.ss.itemType !== vm.cachedItemType) {
        return null
      } else {
        return vm.ss.id
      }
    }
  }
  const getItemsFn = (params) => vm.ss._getAvailableShows(vm.pckg.id, vm.seasonSetId(), 'content/available', params)

  vm.getAvailableShow = getItemsPage(getItemsFn, vm.searchContentAvailableParams, vm.isNotEmptyShow)
  vm.getAvailableShow(vm.items.available.shows)

  /**
   * Get assigned Shows
   *
   * @memberof mwApp/reports.controller:AddShowSetCtrl
   * @type {Object}
   */

  vm.getAssignedShows = function () {
    if (!vm.isNew && vm.cachedItemType === vm.ss.itemType) {
      vm.ss._getAssignedShows(vm.pckg.id, vm.seasonSetId(), 'content/assigned', vm.searchContentParams)
        .then((result) => {
          vm.items.assigned.shows = result.content
          vm.searchContentAssignedParams.last = result.last
          vm.items.assigned.shows.forEach(sh => {
            if (sh.assigned) {
              vm.tvShowIdsToRemove.push(sh.id)
            }
            sh.seasons.forEach(se => {
              if (se.assigned) {
                vm.seasonIdsToRemove.push(se.id)
              }
              se.episodes.forEach(ep => {
                if (ep.assigned) {
                  vm.episodeIdsToRemove.push(ep.id)
                }
              })
            })
          })
        })
    }
  }
  vm.getAssignedShows()

  /**
   * Handler for scroll event of Available select list
   *
   * @param event
   */
  vm.$timerContentAvailableScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    const { last } = vm.searchContentAvailableParams
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAvailableScroll)
      vm.$timerContentAvailableScroll = window.setTimeout(() => {
        vm.getAvailableShow(vm.items.available.shows, false)
      }, 700)
    }
  }

  /**
   * Handler for scroll event of Assigned select list
   *
   * @param event
   */
  vm.$timerContentAssignedScroll = 0
  vm.contentCallbackAssignedScroll = (event) => {
    const {
      page,
      last
    } = vm.searchContentAssignedParams
    if (!last && vm.ss.itemType === vm.cashedItemType && !vm.isNew && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAssignedScroll)
      vm.$timerContentAssignedScroll = window.setTimeout(() => {
        vm.ss._getAssignedShows(vm.pckg.id, vm.seasonSetId(), 'content/assigned', {
          ...vm.searchContentAssignedParams,
          page: page + 1
        })
          .then((result) => {
            vm.items.assigned.shows = vm.items.assigned.shows.concat(result.content)
            vm.searchContentAssignedParams.last = result.last
            vm.searchContentAssignedParams.page = result.number
            result.content.forEach(sh => {
              if (sh.assigned) {
                vm.tvShowIdsToRemove.push(sh.id)
              }
              sh.seasons.forEach(se => {
                if (se.assigned) {
                  vm.seasonIdsToRemove.push(se.id)
                }
                se.episodes.forEach(ep => {
                  if (ep.assigned) {
                    vm.episodeIdsToRemove.push(ep.id)
                  }
                })
              })
            })
          })
      }, 700)
    }
  }

  vm.saveSet = function () {
    vm.setDisable()
    cs._save((data) => {
      data.tvShowIdsToAssign = []
      data.seasonIdsToAssign = []
      data.episodeIdsToAssign = []
      vm.items.assigned.shows.forEach(show => {
        if (vm.ss.itemType === vm.showSet_types.tvShow) {
          data.tvShowIdsToAssign.push(show.id)
        } else {
          show.seasons.forEach(season => {
            if (vm.ss.itemType === vm.showSet_types.season) {
              data.seasonIdsToAssign.push(season.id)
            } else {
              season.episodes.forEach(episode => {
                data.episodeIdsToAssign.push(episode.id)
              })
            }
          })
        }
      })
      if (!vm.isNew) {
        data.tvShowIdsToRemove = vm.tvShowIdsToRemove.filter(sh => !data.tvShowIdsToAssign.includes(sh))
        data.seasonIdsToRemove = vm.seasonIdsToRemove.filter(se => !data.seasonIdsToAssign.includes(se))
        data.episodeIdsToRemove = vm.episodeIdsToRemove.filter(ep => !data.episodeIdsToAssign.includes(ep))
      }
    })
      .then((res) => {
        cs._update().then(() => {
          if (vm.isNew) {
            $location.url(cs._publicListUrl + res.data.payload.id)
          }
        })
      })
      .then(vm.location(cs).reload)
      .finally(vm.unsetDisable)
  }

  vm.getAssignedItems = function () {
    const assignedItems = []
    vm.items.assigned.shows.forEach(show => {
      if (vm.ss.itemType === vm.showSet_types.tvShow) {
        assignedItems.push(show)
      } else {
        show.seasons.forEach(season => {
          if (vm.ss.itemType === vm.showSet_types.season) {
            assignedItems.push(season)
          } else {
            season.episodes.forEach(episode => {
              assignedItems.push(episode)
            })
          }
        })
      }
    })
    assignedItems.forEach(item => { item.false = true })
    return assignedItems
  }

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   */
  vm.submit = function () {
    const assignedItems = []
    let cachedItemsIds = []
    vm.items.assigned.shows.forEach(show => {
      if (vm.ss.itemType === vm.showSet_types.tvShow) {
        assignedItems.push(show)
        cachedItemsIds = angular.copy(vm.tvShowIdsToRemove)
      } else {
        show.seasons.forEach(season => {
          if (vm.ss.itemType === vm.showSet_types.season) {
            assignedItems.push(season)
            cachedItemsIds = angular.copy(vm.seasonIdsToRemove)
          } else {
            season.episodes.forEach(episode => {
              assignedItems.push(episode)
              cachedItemsIds = angular.copy(vm.episodeIdsToRemove)
            })
          }
        })
      }
    })

    if (vm.items.assigned.shows.length === 0 || (!vm.ss.$buyEnabled && !vm.ss.$rentEnabled)) {
      return
    }
    vm.checkIntersection()
      .then(
        () => {
          !vm.hasCSintersection && newItemPriceError($uibModal, cs, cs.assignedSubscriptions, assignedItems, cachedItemsIds)
            .then(() => { vm.saveSet() })
        }
      )
  }

  // see http://marceljuenemann.github.io/angular-drag-and-drop-lists/demo/#/multi

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, type, items, index, toType) {
    $scope.form.$setDirty()
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    const fromTo = `${vm.draggableType}.${type}`
    let foundedShow
    let foundedSeason
    let show
    let season
    if (vm.fromType === toType) {
      items.forEach(item => { item.selected = false })
      return false
    }
    items.forEach((item) => { item.assigned = toType === 'assigned' })
    switch (fromTo) {
      case 'shows.shows' :
        items.forEach((item) => {
          foundedShow = list.shows.find(s => s.id === item.id)
          if (foundedShow) {
            item.seasons.forEach(se => {
              if (!foundedShow.seasons.find(s => s.id === se.id)) {
                foundedShow.seasons.push(se)
              }
            })
            foundedShow.assigned = item.assigned
            foundedShow.seasons.forEach(season => {
              season.assigned = false
              season.episodes.forEach(ep => {
                ep.assigned = false
              })
            })
          } else {
            list.shows = list.shows.slice(0, index).concat(item).concat(list.shows.slice(index))
          }
          item.selected = false
        })

        return true
      case 'seasons.shows' :
        foundedShow = list.shows.find(show => show.id === vm.showFromSeason.id)
        if (foundedShow) {
          foundedShow.assigned = false
          foundedSeason = foundedShow.seasons.find(season => season.id === items[0].id)
          if (foundedSeason) {
            foundedSeason.episodes = foundedSeason.episodes.concat(items[0].episodes)
            foundedSeason.assigned = items[0].assigned
            foundedSeason.episodes.forEach(ep => { ep.assigned = false })
          } else {
            foundedShow.seasons.push(items[0])
          }
        } else {
          show = angular.copy(vm.showFromSeason)
          show.seasons = [items[0]]
          list.shows = list.shows.slice(0, index).concat([show]).concat(list.shows.slice(index))
        }
        items.forEach(item => item.selected = false)
        return true
      case 'seasons.seasons':
        if (vm.showFromSeason.id !== list.id) {
          return false
        }
        foundedSeason = list.seasons.find(season => season.id === items[0].id)
        if (foundedSeason) {
          foundedSeason.episodes = foundedSeason.episodes.concat(items[0].episodes)
          foundedSeason.assigned = items[0].assigned
          foundedSeason.episodes.forEach(ep => { ep.assigned = false })
        } else {
          list.seasons.push(items[0])
        }
        list.assigned = false
        items.forEach(item => item.selected = false)
        return true
      case 'episodes.shows':
        foundedShow = list.shows.find(show => show.id === vm.showFromEpisode.id)
        if (foundedShow) {
          foundedSeason = foundedShow.seasons.find(season => season.id === vm.seasonFromEpisode.id)
          if (foundedSeason) {
            foundedSeason.episodes.push(items[0])
            foundedSeason.assigned = false
          } else {
            season = angular.copy(vm.seasonFromEpisode)
            season.episodes = [items[0]]
            foundedShow.seasons.push(season)
          }
          foundedShow.assigned = false
        } else {
          show = angular.copy(vm.showFromEpisode)
          show.seasons = [vm.seasonFromEpisode]
          show.seasons[0].episodes = [items[0]]
          list.shows.push(show)
        }
        items.forEach(item => item.selected = false)
        return true
      case 'episodes.seasons':
        if (list.id !== vm.showFromEpisode.id) {
          return false
        }
        foundedSeason = list.seasons.find(season => season.id === vm.seasonFromEpisode.id)
        if (foundedSeason) {
          foundedSeason.episodes.push(items[0])
        } else {
          season = angular.copy(vm.seasonFromEpisode)
          season.episodes = [items[0]]
          list.seasons.push(season)
        }
        items.forEach(item => item.selected = false)
        return true
      case 'episodes.episodes':
        if (list.id !== vm.seasonFromEpisode.id) {
          return false
        }
        list.episodes = list.episodes.slice(0, index).concat(items).concat(list.episodes.slice(index))
        items.forEach(item => item.selected = false)
        return true
      default :
        items.forEach(item => item.selected = false)
        items[0].assigned = !items[0].assigned
        return false
    }
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, type, link, fromType, showFromEpisode = null) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    vm.draggableType = type
    vm.fromType = fromType
    if (type === 'seasons') {
      vm.showFromSeason = angular.copy(list)
      vm.showFromSeason.seasons = []
    }
    if (type === 'episodes') {
      vm.seasonFromEpisode = angular.copy(list)
      vm.showFromEpisode = angular.copy(showFromEpisode)
    }
    link.selected = true
    return list[type].filter(link => link.selected)
  }

  /**
   * Delete show from showSet
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   */
  vm.deleteShowFromSet = function (show) {
    event.preventDefault()
    show.selected = false
    if (show.assigned) {
      vm.items.available.shows.push({ ...show, assigned: false })
    } else {
      const availableShow = vm.items.available.shows.find(sh => sh.id === show.id)
      if (availableShow) {
        show.seasons.forEach(se => {
          const availableSeason = availableShow.seasons.find(s => s.id === se.id)
          if (availableSeason) {
            se.episodes.forEach(ep => {
              availableSeason.episodes.push({ ...ep, assigned: false })
            })
          } else {
            availableShow.seasons.push({ ...se, assigned: false })
          }
        })
      } else {
        vm.items.available.shows.push(show)
      }
    }
    vm.items.assigned.shows = vm.items.assigned.shows.filter(sh => sh.id !== show.id)
    vm.checkIntersection(true)
    $scope.form.$setDirty()
  }

  /**
   * Delete season from showSet
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   */
  vm.deleteSeasonFromSet = function (show, season) {
    // eslint-disable-next-line no-undef
    event.preventDefault()
    show.seasons.selected = false

    let availableShow = vm.items.available.shows.find(s => s.id === show.id)
    if (availableShow) {
      if (season.assigned) {
        availableShow.seasons.push({ ...season, assigned: false })
      } else {
        const availableSeason = availableShow.seasons.find(se => se.id === season.id)
        if (availableSeason) {
          season.episodes.forEach(ep => {
            availableSeason.episodes.push({ ...ep, assigned: false })
          })
        } else {
          vm.items.available.shows.push({ ...show, assigned: false, seasons: [{ ...season }] })
        }
      }
    } else {
      availableShow = { ...show, assigned: false, seasons: [{ ...season }] }
      vm.items.available.shows.push(availableShow)
      if (show.assigned) {
        show.assigned = false
        show.seasons.forEach(se => { se.assigned = true })
      }
    }
    show.seasons = show.seasons.filter(se => se.id !== season.id)

    vm.items.assigned.shows = vm.items.assigned.shows.filter(sh => sh.seasons.length > 0 || sh.assigned)
    vm.checkIntersection(true)
    $scope.form.$setDirty()
  }

  /**
   * Delete season from showSet
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   */
  vm.deleteEpisodeFromSet = function (show, season, episode) {
    // eslint-disable-next-line no-undef
    event.preventDefault()
    season.episodes.selected = false
    let availableShow = vm.items.available.shows.find(sh => sh.id === show.id)
    let availableSeason
    if (availableShow) {
      availableSeason = availableShow.seasons.find(se => se.id === season.id)
      if (availableSeason) {
        availableSeason.episodes.push({ ...episode, assigned: false })
      } else {
        availableSeason = { ...season, assigned: false, episodes: [{ ...episode, assigned: false }] }
        availableShow.seasons.push(availableSeason)
        season.assigned = false
      }
    } else {
      availableShow = {
        ...show,
        assigned: false,
        seasons: [{ ...season, episodes: [{ ...episode, assigned: false }] }]
      }
      vm.items.available.shows.push(availableShow)
      if (show.assigned) {
        show.assigned = false
        show.seasons.forEach(s => {
          if (s.id !== season.id) {
            s.assigned = true
          }
        })
      }
    }
    season.episodes = season.episodes.filter(ep => ep.id !== episode.id)
    season.episodes.forEach(ep => { ep.assigned = true })
    vm.items.assigned.shows.forEach(sh => {
      sh.seasons = sh.seasons.filter(se => se.episodes.length > 0 || se.assigned)
    })
    vm.items.assigned.shows = vm.items.assigned.shows.filter(sh => sh.seasons.length > 0 || sh.assigned)
    $scope.form.$setDirty()
    vm.checkIntersection(true)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => { item.selected = false })
    list.dragging = false
    vm.checkIntersection()
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list, type) {
    let fromShow
    let fromSeason
    if (vm.fromType === 'assigned') {
      if (type === 'seasons') {
        fromShow = vm.items.assigned.shows.find(show => show.id === vm.showFromSeason.id)
        if (vm.showFromSeason.assigned) {
          fromShow.assigned = false
          fromShow.seasons.forEach(season => season.assigned = true)
        }
      }
      if (type === 'episodes') {
        fromShow = vm.items.assigned.shows.find(show => show.id === vm.showFromEpisode.id)
        fromSeason = fromShow.seasons.find(season => season.id === vm.seasonFromEpisode.id)
        if (fromSeason.assigned) {
          fromSeason.assigned = false
        } else if (fromShow.assigned) {
          fromShow.assigned = false
          fromShow.seasons.forEach(season => {
            if (season.id !== fromSeason.id) {
              season.assigned = true
            }
          })
        }
        fromSeason.episodes.forEach(ep => {
          ep.assigned = true
        })
      }
    }
    list[type] = list[type].filter(item => !item.selected)
  }

  /**
   * Method for select/deselect items
   *
   * @param item
   * @param event
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   */
  vm.selectItem = function (item, event) {
    vm.stopEvent(event)
    item.selected = !item.selected
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicUrl + '/contentSets#tv_show_sets')
    }
  }

  vm.openItem = function (item, event) {
    vm.stopEvent(event)
    item.is_open = !item.is_open
  }

  vm.filterAssigned = ''
  vm.filterAssignedShow = function (show) {
    return vm.filterAssigned.length > 0
      ? show.name.toLowerCase().includes(vm.filterAssigned.toLowerCase())
      : true
  }

  vm.selectType = function (type) {
    vm.ss.itemType = type
    vm.items.assigned.shows = []
    vm.searchContentAssignedParams = angular.copy(vm.searchContentParams)
    vm.getAvailableShow(vm.items.available.shows)
    vm.getAssignedShows()
  }

  vm.openConflicts = function (item) {
    event.stopPropagation()
    event.preventDefault()
    item.openConflict = true
    openCSModal($uibModal, vm.ss, item, vm.checkIntersection)
  }

  vm.checkIntersection = function (checkOnDelete = false) {
    if (checkOnDelete && !vm.hasCSintersection) { return }

    vm.setDisable()
    return checkCSIntersection($http, alertLiteSvc, vm.ss, vm.getAssignedItems(), vm.isNew)
      .then(data => { vm.hasCSintersection = data })
      .finally(vm.unsetDisable)
  }
}
